import {MensagemModel} from "../models/mensagem.model";

export class DTOModel<T> {
  public entity?: T;
  public sucesso?: boolean;
  public collection?: T[];
  public msgs?: MensagemModel[];
}
